import Notice from '../components/Notice';

function LogoutPage() {
  return <Notice mt={20}>You have been logged out.</Notice>;
}

export default LogoutPage;
